import { Storage } from '@ionic/storage';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router,NavigationExtras } from '@angular/router';

@Component({
  selector: 'app-sub-category',
  templateUrl: './sub-category.component.html',
  styleUrls: ['./sub-category.component.scss'],
})
export class SubCategoryComponent implements OnInit {
  subcat:any;
  cart_count:any=0;
  constructor(public storage:Storage, private route: ActivatedRoute, private router: Router,) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      console.log(JSON.parse(params.sub_cat))
      this.subcat=JSON.parse(params.sub_cat);
      // if (params && params.special) {
      //   this.data = JSON.parse(params.special);
      // }
      
    });
  }
ionViewWillEnter(){
  if(localStorage.getItem('cart_count')){
    this.cart_count=localStorage.getItem('cart_count')
  }else{
    this.cart_count='';
  }
}
get_cat_id(item){
console.log(item)
  let category_id=item.category_id
  let status="category";
    let navigationExtras: NavigationExtras = {
      queryParams: {
        category_id: JSON.stringify(category_id),
        status: JSON.stringify(status)
      }
    };
    this.router.navigate(['/productlist'], navigationExtras); 
}
}
